import React, {Component} from 'react';
import isPage from '../hoc/isPage';
import { Link, Redirect } from 'react-router-dom';
import { Input } from '@progress/kendo-react-inputs';
import { Button } from "@progress/kendo-react-buttons";
import { validatePasswordComplexity } from '../helpers';

class ChangePasswordPage extends Component {
    state = {
        password: "",
        duplicatePassword: "",
        changedPassword: false,
        navigateBack: false // user has indicated he wants to return to dashboard
    }
    handleChange = (e) => {
        this.setState({
            [e.target.name] : e.target.value
        });
    }
    closeChangePassword = () => {
        this.setState({
            navigateBack: true
        });
    }
    changePassword = (e) => {
        e.preventDefault();
        // check if both passwords match
        
        if (this.state.password.localeCompare(this.state.duplicatePassword) !== 0){
            this.props.alert("error",this.props.returnLocalizedString("m0023"), this.props.returnLocalizedString("m0113"));
            return;
        }

        // validate password complexity
        if (!validatePasswordComplexity(this.state.password)){
            this.props.alert("error",this.props.returnLocalizedString("m0023"), this.props.returnLocalizedString("m0114"));
            return;
        }

        // call API to change up the password
        const newPassword = {'newPassword' : this.state.password};
        this.props.postData("/api/portal/user/ChangePassword", newPassword).then(response => {
            this.setState({changedPassword: true});
            //this.props.alert("success", this.props.returnLocalizedString("m0036"), this.props.returnLocalizedString("m0116"));
        }).catch(error => {
            this.props.alert("error", this.props.returnLocalizedString("m0023"), this.props.returnLocalizedString("m0115"));
        });
    }
    render(){
        if (this.state.navigateBack){
            return <Redirect to="/dashboard"/>;
        }

        const inputFontSize = Math.min(1.7 * 225/this.props.returnLocalizedString("m0122").length, 14) + 'px'
        const buttonFontSize =  Math.min(1.5 * 200/this.props.returnLocalizedString("m0119").length, 14) + 'px'

        const content = (this.state.changedPassword) ? (
            <React.Fragment>
                <h1>{this.props.returnLocalizedString("m0036")}</h1>
                <p>{this.props.returnLocalizedString("m0036")}</p>
                <p><Link className="hyperlink" to="/dashboard">{this.props.returnLocalizedString("m0118")}</Link></p>
            </React.Fragment>
        ) : (
            <React.Fragment>
                <div className="closer">
                    <img src={require('../img/icon-close.png')} onClick={this.closeChangePassword} alt="" />
                </div>
                <h1>{this.props.returnLocalizedString("m0119")}</h1>
                <p>{this.props.returnLocalizedString("m0120")}</p>     

                <div className="bottom-margin-10 width-225">
                    <Input className = "textbox" type="password" onChange={this.handleChange} required={true} label={this.props.returnLocalizedString("m0121")} name='password' value={this.state.password} />
                </div>
                <div className="bottom-margin-10 width-225">
                    <Input className = "textbox" type="password" style={{fontSize: inputFontSize}} onChange={this.handleChange} required={true} label={this.props.returnLocalizedString("m0122")} name='duplicatePassword' value={this.state.duplicatePassword} />
                </div>
                <div className="bottom-margin-20">
                    {this.props.returnLocalizedString("m0123")}
                </div>
                <Button style = {{fontSize: buttonFontSize, minWidth: '220px'}} primary={true} onClick={this.changePassword}>{this.props.returnLocalizedString("m0119")}</Button>
            </React.Fragment>

        );

        //!DBTRANS! @m0023@ Error! !DEVNOTE! Action status
        //!DBTRANS! @m0036@ Success! !DEVNOTE! Action status
        //!DBTRANS! @m0113@ Your passwords need to match !DEVNOTE! Action status reason
        //!DBTRANS! @m0114@ Your passwords do not meet the minimum complexity requirements. !DEVNOTE! Action status reason
        //!DBTRANS! @m0115@ The passowrd could not be changed. Please try again. !DEVNOTE! Action status
        //!DBTRANS! @m0116@ The password was sucessfully changed. !DEVNOTE! Action status
        //!DBTRANS! @m0117@ Your password has been sucessfully changed. !DEVNOTE! Action status
        //!DBTRANS! @m0118@ Head back to the portal. !DEVNOTE! Button label 
        //!DBTRANS! @m0119@ Change Password !DEVNOTE! Button label
        //!DBTRANS! @m0120@ Please enter your new password. !DEVNOTE! Text label
        //!DBTRANS! @m0121@ Password !DEVNOTE! Text field label
        //!DBTRANS! @m0122@ Re-enter your password !DEVNOTE! Text field label
        //!DBTRANS! @m0123@ Password must contain a minimum of 8 characters including at least one lowercase character, one uppercase, one number, and one special character. !DEVNOTE! Text field description 

        return (
            <section className="app-login register">
                <section className="inner">
                    {content}
                    
                </section>
            </section>
        );
    }
}
export default isPage(ChangePasswordPage);


// WEBPACK FOOTER //
// ./src/containers/ChangePasswordPage.js